import { render, staticRenderFns } from "./Privat.vue?vue&type=template&id=78e258fc&scoped=true&"
import script from "./Privat.vue?vue&type=script&lang=js&"
export * from "./Privat.vue?vue&type=script&lang=js&"
import style0 from "./Privat.vue?vue&type=style&index=0&id=78e258fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e258fc",
  null
  
)

export default component.exports